import React from "react";
import { StyledLoader } from "./Loader.styled";
import { Spacing } from "../../theme/wscTheme.types";

export interface LoaderProps {
  size: Spacing;
  isDisabled?: boolean;
}

export default function Loader(props: LoaderProps) {
  return <StyledLoader {...props} aria-label="Loading..." />;
}
